/**
 * Canonical placeholder for a metric cell with no value. Lives in its own
 * module so both formatters and enhanceValue renderers can share it without
 * an import cycle through constants.js.
 */
export const NIL_DISPLAY = "-"
